/* eslint-disable import/no-anonymous-default-export */
import produce from 'immer'

export const initialState = {
  loading: true,
  brochure: {
    name: '',
    cover: '',
    endDate: '',
    startDate: '',
    images: [],
  },
}

export default (state, action) =>
  produce(state, (draftState) => {
    switch (action.type) {
      // brochure ations
      case 'BROCHURE_CLEAR': {
        draftState.brochure = initialState.brochure
        break
      }
      case 'BROCHURE_ADD': {
        draftState.brochure = action.brochure
        break
      }
      case 'BROCHURES_CHANGE_LOADING': {
        draftState.loading = action.loading
        break
      }

      default:
        return draftState
    }
  })
